import { SourceSpecification, LayerSpecification } from 'maplibre-gl';

import { layerObj, layerSource, property, layerType , expressionType} from './Types';

import { Map } from './Map';

import { Layer} from './Layer';

// import layout from './const/layout.json';
// import defaults from './const/default.json';
// import expression from "./expression";

export class RasterLayer extends Layer {
  constructor(
    layerSource: layerSource,
    mapObj: Map,
    sourceLayerId?: string,
    layerId?: string,
    sourceId?: string
  ) {
    super(layerSource, mapObj, sourceLayerId, layerId, sourceId);

    this.sourceType = 'raster';
    this.colorType = 'raster-color';
    this.layerType = this.source.layer_type;
    // const prefix = 'raster';
    // this.layerId = `${prefix}/${this.layerId}`;
  }

  toMaplibreLayer = (opt: LayerSpecification) => {
    let layerObj: layerObj;

    let { layerId } = this;

    let layerRepeatNumber = 1;
    layerId = layerId.split('#')[0]

    let layerList = this.mapObj.getLayersOrder();

    if (layerList.includes(`${layerId}`)) {
      layerRepeatNumber += 1;
    }

    for (const layer of this.mapObj.getStyle().layers) {
      if (layerList.includes(`${layerId}#${layerRepeatNumber}`)) {
        layerRepeatNumber += 1;
      }
    }
    if(layerRepeatNumber > 0) layerId = `${layerId}#${layerRepeatNumber}`;

    this.layerId = layerId;

    switch (this.source.layer_type) {
      case 'raster':
        layerObj = {
          id: layerId,
          type: 'raster',
          source: this.sourceId,
        };

        break;
      case 'mosaic':
        layerObj = {
          id: layerId,
          type: 'raster',
          source: this.sourceId,
        };
        break;
      case 'hillshade':
        layerObj = {
          id: layerId,
          type: 'hillshade',
          source: this.sourceId,
        };
        break;
      default:
        layerObj = {
          id: layerId,
          type: 'raster',
          source: this.sourceId,
        };
        break;
    }

    if (opt.layout) layerObj.layout = opt.layout;
    if (opt.paint) layerObj.paint = opt.paint;
    return layerObj;
  };

  toMaplibreSource = async () => {
    // const minzoom = LAYER_MIN_ZOOM;
    // const maxzoom = LAYER_MAX_ZOOM;

    let sourceObj: SourceSpecification;
    if (
      this.source.layer_type === 'hillshade'
    ){
      sourceObj = {
        type: 'raster-dem',
        // tileSize: 256,
        // minzoom,
        // maxzoom,
      };
    }else {
      sourceObj = {
        type: 'raster',
        // tileSize: 256,
        // minzoom,
        // maxzoom,
      };
    }

    let layerInfo;

    let tileJsonURL;

    if ((this.source.layer_source_type === 'raster' && this.source.layer_type === 'raster') || (this.source.layer_source_type === 'raster' && this.source.layer_type === 'hillshade')
    ) {
      // layerInfo = await this.mapObj.server.getRasterTilejson(this.source.uuid);
      // console.log(layerInfo)
      tileJsonURL = await this.mapObj.server._makeRasterEndpoint(
        this.source.uuid
      );
    } else if ((this.source.layer_source_type === 'mosaic' && this.source.layer_type === 'mosaic') || (this.source.layer_source_type === 'mosaic' && this.source.layer_type === 'hillshade')
    ) {
      // layerInfo = await this.mapObj.server.getMosaicTilejson(this.source.uuid);
      // console.log(layerInfo)
      tileJsonURL = await this.mapObj.server._makeMosaicEndpoint(
        this.source.uuid
      );
    } else {
      try {
        layerInfo = await this.source.getTilejson();
      } catch (error) {}
    }

    tileJsonURL = `${tileJsonURL}tilejson.json`;

    try {
      // if (
      //   this.source.layer_source_type === 'hillshade' &&
      //   this.source.layer_type === 'hillshade'
      // ){
      //   sourceObj.url = layerInfo.tiles;
      // }else {
        sourceObj.url = tileJsonURL;
      // }
      
    } catch (error) {}

    return sourceObj;
  };

  addHillshade = () =>{
    if (this.mapObj.getLayer(this.layerId)) {
      let layerSource = this.mapObj.getSource(<string>this.mapObj.getLayer(this.layerId)?.source);
      if (layerSource?.type === 'raster-dem'){
        throw new Error("The layer itself is a hillshade!");
      }
    }

    if (this.mapObj.getLayer(`${this.layerId}$hillshade`)) {
      this.mapObj.removeLayer(`${this.layerId}$hillshade`);
    }

    this.setProperty('visibility', 'none');

    if (!this.mapObj.getSource(`${this.sourceId.replace(this.layerType,'hillshade')}`)){
      this.mapObj.addSource(`${this.sourceId.replace(this.layerType,'hillshade')}`, {
        "url": `${(<any>this.mapObj.getSource(this.sourceId)).url}`,
        "type": "raster-dem"
      })
    }

   

    this.mapObj.addLayer({
      id: `${this.layerId}$hillshade`,
      type: 'hillshade',
      source: `${this.sourceId.replace(this.layerType,'hillshade')}`
    });

    this._setLayerProperty('maxzoom',this.mapObj.getLayer(this.layerId)?.maxzoom ,'hillshade');
    this._setLayerProperty('minzoom',this.mapObj.getLayer(this.layerId)?.minzoom ,'hillshade');

    // let newOrder = this.mapObj.style._order.indexOf(this.layerId);
    this.mapObj.moveLayerOrder(`${this.layerId}$hillshade`, this.layerId);

    this.mapObj.moveLayerOrder('geobox-gl-splash-circle');
  }

  removeHillshade = () =>{
    const visibility = this.mapObj.getLayoutProperty(
      `${this.layerId}$hillshade`,
      'visibility'
    );

    

    if (this.mapObj.getLayer(`${this.layerId}$hillshade`)) {
      this.mapObj.removeLayer(`${this.layerId}$hillshade`);
    }

    if (this.mapObj.getSource(`${this.sourceId}$hillshade`)){
      this.mapObj.removeSource(`${this.sourceId}$hillshade`)
    }

    if (visibility !== 'none') {
      this.setProperty('visibility', 'visible');
    }
  }

  setHillshadeProperty= (type: property, value: any)=>{
    this._setLayerProperty(type, value,'hillshade');
  }

  getHillshadeProperty= (type: property) => {
    return this._getLayerProperty(type, 'hillshade');
  }

  addRaster = () =>{
    if (this.mapObj.getLayer(this.layerId)) {
      let layerSource = this.mapObj.getSource(<string>this.mapObj.getLayer(this.layerId)?.source);
      if (layerSource?.type === 'raster'){
        throw new Error("The layer itself is a raster!");
      }
    }

    if (this.mapObj.getLayer(`${this.layerId}$raster`)) {
      this.mapObj.removeLayer(`${this.layerId}$raster`);
    }

    this.setProperty('visibility', 'none');

    if (!this.mapObj.getSource(`${this.sourceId.replace('hillshade','raster')}`)){
      this.mapObj.addSource(`${this.sourceId.replace('hillshade','raster')}`, {
        "url": `${(<any>this.mapObj.getSource(this.sourceId)).url}`,
        "type": "raster"
      })
    }

    this.mapObj.addLayer({
      id: `${this.layerId}$raster`,
      type: 'raster',
      source: `${this.sourceId.replace('hillshade','raster')}`
    });

    this.mapObj.moveLayerOrder(`${this.layerId}$raster`, this.layerId);

    this._setLayerProperty('maxzoom',this.mapObj.getLayer(this.layerId)?.maxzoom ,'raster');
    this._setLayerProperty('minzoom',this.mapObj.getLayer(this.layerId)?.minzoom ,'raster');

    this.mapObj.moveLayerOrder('geobox-gl-splash-circle');
  }

  removeRaster = () =>{
    const visibility = this.mapObj.getLayoutProperty(
      `${this.layerId}$raster`,
      'visibility'
    );

    if (this.mapObj.getLayer(`${this.layerId}$raster`)) {
      this.mapObj.removeLayer(`${this.layerId}$raster`);
    }

    if (this.mapObj.getSource(`${this.sourceId}$raster`)){
      this.mapObj.removeSource(`${this.sourceId}$raster`)
    }
    
    if (visibility !== 'none') {
      this.setProperty('visibility', 'visible');
    }
  }

  setRasterProperty= (type: property, value: any)=>{
    this._setLayerProperty(type, value,'raster');
  }

  getRasterProperty= (type: property) => {
    return this._getLayerProperty(type, 'raster');
  }

  // setSubLayerProperty = (
  //   type: property,
  //   value: any,
  //   subLayerType: 'hillshade' | 'raster'
  // ) => {
  //   try {
  //     if (type === 'maxzoom') {
  //       this.mapObj.setLayerZoomRange(
  //         `${this.layerId}$${subLayerType}`,
  //         this.mapObj.getLayer(`${this.layerId}$${subLayerType}`)?.minzoom || 0,
  //         <number>value
  //       );
  //     } else if (type === 'minzoom') {
  //       this.mapObj.setLayerZoomRange(
  //         `${this.layerId}$${subLayerType}`,
  //         <number>value,
  //         this.mapObj.getLayer(`${this.layerId}$${subLayerType}`)?.maxzoom || 24
  //       );
  //     }else {
  //       let layerType: layerType = 'line';
  //       if (this.mapObj.getLayer(`${this.layerId}$${subLayerType}`))
  //         layerType = <layerType>(
  //           this.mapObj.getLayer(`${this.layerId}$${subLayerType}`)?.type
  //         );

  //       let group = 'paint';

  //       if (layout[layerType].paint.includes(type)) {
  //         group = 'paint';
  //       } else {
  //         group = 'layout';
  //       }

  //       if (layerType === 'symbol') {
  //         for (const field of this.allFields) {
  //           if (field.name === value) {
  //             value = `{${value}}`;
  //             break;
  //           }
  //         }
  //       }

  //       if (group === 'paint') {
  //         this.mapObj.setPaintProperty(
  //           `${this.layerId}$${subLayerType}`,
  //           type,
  //           value
  //         );
  //       } else if (type === 'visibility') {
  //         this.mapObj.setLayoutProperty(
  //           `${this.layerId}$${subLayerType}`,
  //           type,
  //           value
  //         );
  //       } else {
  //         this.mapObj.setLayoutProperty(`${this.layerId}$${subLayerType}`, type, value);
  //       }
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

 

  // getSubLayerProperty = (
  //   type: property,
  //   subLayerType: 'hillshade' | 'raster'
  // ) => {
  //   let propertyValue;
  //   let paintProperty: any;
  //   try {
  //     if (type === 'maxzoom') {
  //       propertyValue = {"basic": this.mapObj.getLayer(`${this.layerId}$${subLayerType}`)?.maxzoom || defaults['maxzoom']};
  //     } else if (type === 'minzoom') {
  //       propertyValue = {"basic":this.mapObj.getLayer(`${this.layerId}$${subLayerType}`)?.minzoom || defaults['minzoom']};
  //     }else if (type === 'highlight-color') {
  //       paintProperty = this.mapObj.getPaintProperty(this.layerId, <string>this.colorType);
  //       if (paintProperty[0] === 'case') {
  //         if ((["string", "number", "boolean"].includes(typeof paintProperty[4]))) {
  //           propertyValue = {"basic": paintProperty[4]};
  //         }else {
  //           propertyValue = {"case": paintProperty[4]};
  //         }
  //       } else if (paintProperty[0] === 'interpolate') {
  //         propertyValue = {"interpolate": paintProperty[4][4]};
  //       }
  //     } else if (type === 'select-color') {
  //       paintProperty =  this.mapObj.getPaintProperty(this.layerId, <string>this.colorType);
  //       if (paintProperty[0] === 'case') {
  //         if ((["string", "number", "boolean"].includes(typeof paintProperty[2]))) {
  //           propertyValue = {"basic": paintProperty[2]};
  //         }else {
  //           propertyValue = {"case": paintProperty[2]};
  //         }
  //       } else if (paintProperty[0] === 'interpolate') {
  //         propertyValue = {"interpolate": paintProperty[4][2]};
  //       }
      
  //     } else {
  //       let layerType: layerType = 'line';
  //       if (this.mapObj.getLayer(`${this.layerId}$${subLayerType}`))
  //         layerType = <layerType>this.mapObj.getLayer(`${this.layerId}$${subLayerType}`)?.type;

  //       let group = 'paint';
      
  //       if (layout[layerType].paint.includes(type)) {
  //         group = 'paint';
  //       } else {
  //         group = 'layout';
  //       }
     
  //       if (group === 'paint') {
  //          paintProperty = this.mapObj.getPaintProperty(`${this.layerId}$${subLayerType}`, type);
  //         if(typeof paintProperty !== "boolean" && !paintProperty){
  //           propertyValue = {"basic": (<any>defaults)[type]};
  //         } else if (paintProperty && ((["string", "number", "boolean"].includes(typeof paintProperty)))){
  //           propertyValue = {"basic": paintProperty};
  //         } else if (paintProperty && paintProperty[0] === 'case') {
  //            propertyValue = {"case": paintProperty};
  //         } else if (paintProperty && paintProperty[0] === 'interpolate') {
  //           let propertyObject: expressionType = <expressionType>expression.parse(paintProperty);
            
  //           if (propertyObject?.inputs.length === 1){
  //             if ((["string", "number", "boolean"].includes(typeof paintProperty[5]))) {
  //               propertyValue = {"basic": paintProperty[4][5]};
  //             }else {
  //               propertyValue = {"case": paintProperty[4][5]};
  //             }
              
  //           }else {
  //             for (let index = 0; index < <number>propertyObject?.outputs.length; index++) {
               
  //               propertyObject.outputs[index] = propertyObject?.outputs[index];
  //               propertyObject.stops[index][1] = propertyObject.stops[index][1];
  //             }
  //             propertyValue = {"interpolate": propertyObject.stops, "field":propertyObject.fieldName};
  //           }
            
  //         }else if (paintProperty && typeof paintProperty === 'object' && Object.keys(paintProperty)[0] === 'stops') {
  //           propertyValue = {"interpolate": paintProperty.stops, "field":"zoom"};
            
  //         }else {
  //           propertyValue = {"basic": paintProperty};
  //         }
  //       } else {
  //         paintProperty = this.mapObj.getLayoutProperty(`${this.layerId}$${subLayerType}`, type);

  //         if(typeof paintProperty !== "boolean" && !paintProperty){
  //           propertyValue = {"basic": (<any>defaults)[type]};
  //         } else if (paintProperty && ((["string", "number", "boolean"].includes(typeof paintProperty)))){
  //           propertyValue = {"basic": paintProperty};
  //         } else if (paintProperty && paintProperty[0] === 'case') {
  //           if ((["string", "number", "boolean"].includes(typeof paintProperty[5]))) {
  //             propertyValue = {"basic": paintProperty};
  //           }else {
  //             propertyValue = {"case": paintProperty};
  //           }
            
  //         } else if (paintProperty && paintProperty[0] === 'interpolate') {
  //           let propertyObject: expressionType = <expressionType>expression.parse(paintProperty);
            
  //           if (propertyObject?.inputs.length === 1){
  //             if ((["string", "number", "boolean"].includes(typeof paintProperty))) {
  //               propertyValue = {"basic": paintProperty};
  //             }else {
  //               propertyValue = {"case": paintProperty};
  //             }
              
  //           }else {
  //             propertyValue = {"interpolate": propertyObject.stops, "field":propertyObject.fieldName};
  //           }
            
  //         }else if (paintProperty && typeof paintProperty === 'object' && Object.keys(paintProperty)[0] === 'stops') {
  //           propertyValue = {"interpolate": paintProperty.stops, "field":"zoom"};
  //         }else {
  //           propertyValue = {"basic": paintProperty};
  //         }
  //       }
  //     }
    
  //     return propertyValue;
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  duplicate = () => {
    let style = this.mapObj.getStyle();

    let layerStyle = style.layers.find(layer => layer.id === this.layerId);

    let layerId = this.layerId;

    layerId = layerId.split('#')[0];

    let layerRepeatNumber = 1;

    let layerList = this.mapObj.getLayersOrder();

    for (const layer of style.layers) {
      if (layerList.includes(`${layerId}#${layerRepeatNumber}`)) {
        layerRepeatNumber += 1;
      }
    }

    layerId = `${layerId}#${layerRepeatNumber}`;

    (<any>layerStyle).id = layerId;

    let rasterLayer = new RasterLayer(this.source,  this.mapObj, this.sourceLayer, layerId);

    this.mapObj.addLayer(<LayerSpecification>layerStyle);

    this.mapObj.libreMapRasterLayers[layerId] = <RasterLayer>rasterLayer;

    // let newOrder = this.mapObj.style._order.indexOf(this.layerId);

    this.mapObj.moveLayerOrder(layerId, this.layerId);

    if (this.mapObj.getLayer(`${this.layerId}$hillshade`)) {
      layerStyle = style.layers.find(layer => layer.id === `${this.layerId}$hillshade`);

      layerId = `${layerId}$hillshade`;
  
      (<any>layerStyle).id = layerId;

      this.mapObj.addLayer(<LayerSpecification>layerStyle);
    }

    if (this.mapObj.getLayer(`${this.layerId}$raster`)) {
      layerStyle = style.layers.find(layer => layer.id === `${this.layerId}$raster`);

      layerId = `${layerId}$raster`;
  
      (<any>layerStyle).id = layerId;

      this.mapObj.addLayer(<LayerSpecification>layerStyle);
    }

    this.mapObj.moveLayerOrder('geobox-gl-splash-circle');
    
    return rasterLayer;
  }
}
